import { Component, OnInit } from '@angular/core';

import { Router } from '@angular/router';
import { LoginForm } from 'src/app/class/datatype';
import { AuthService } from 'src/app/services/auth/auth.service';
import { ErrorhandlerService } from 'src/app/services/errorhandler/errorhandler.service';
import { LandingRouteService } from 'src/app/services/auth/landing-route.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  public user: LoginForm = new LoginForm();
  public isLoading = false;
  public showPassword = false;
  public currentYear = new Date().getFullYear();

  constructor(
    private auth: AuthService,
    private eHandler: ErrorhandlerService,
    private router: Router,
    private landing: LandingRouteService
  ) {}

  login() {
    this.isLoading = true;
    this.auth.login(this.user).subscribe({
      next: data => {
        this.auth.setAuthData(data);
        // Kasir-saja langsung ke layar kasir; akun lain ke dashboard.
        this.router.navigateByUrl(this.landing.homeRoute());
      },
      error: err => {
        this.isLoading = false;
        this.eHandler.errorHttp(err);
      },
    });
  }

  ngOnInit() {
    this.auth.clearAuthData();
  }
}
